/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Mock_SubscriptionInputs */

const en_plan_mock_subscription = /** @type {(inputs: Plan_Mock_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mock Subscription`)
};

const es_plan_mock_subscription = /** @type {(inputs: Plan_Mock_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción simulada`)
};

/**
* | output |
* | --- |
* | "Mock Subscription" |
*
* @param {Plan_Mock_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_mock_subscription = /** @type {((inputs?: Plan_Mock_SubscriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Mock_SubscriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_mock_subscription(inputs)
	return en_plan_mock_subscription(inputs)
});